import { init, refresh } from 'aos';

export default function initializeAos() {
  document.addEventListener('pat-changeheight', function() {
    refresh();
  });

  init({
    offset: 300,
    disable: 'mobile',
  });
}
